'use strict';
import { RRule } from 'rrule';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ActivitiesCtrl
 * @description
 * # ActivitiesCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ActivitiesCtrl', [
    '$scope',
    '$q',
    '$window',
    'SearchClientsAndProspects',
    'Activity',
    'Client',
    '$mdDialog',
    'ActivityTypeCatalog',
    'cfpLoadingBar',
    'toaster',
    'Project',
    'ProductCatalog',
    'FileSaver',
    'Employee',
    'Holyday',
    'AppSetting',
    '$rootScope',
    '$timeout',
    'ActivityDraft',
    'ActivityTemplate',
    'GoogleCalendarEvents',
    'ImportPendingList',
    function (
      $scope,
      $q,
      $window,
      SearchClientsAndProspects,
      Activity,
      Client,
      $mdDialog,
      ActivityTypeCatalog,
      cfpLoadingBar,
      toaster,
      Project,
      ProductCatalog,
      FileSaver,
      Employee,
      Holyday,
      AppSetting,
      $rootScope,
      $timeout,
      ActivityDraft,
      ActivityTemplate,
      GoogleCalendarEvents,
      ImportPendingList,
    ) {
      $scope.activities = [];
      $scope.currentActivity = {};
      $scope.currentEmployee = {};
      $scope.newCurrentActivity = {};
      $scope.newActivity = {};
      $scope.actionTypes = [
        { id: 'project', name: "Proyecto" },
        { id: 'support', name: "Soporte" },
        { id: 'quote', name: "Propuesta / Comercial" },
        { id: 'rh', name: "Recursos Humanos" },
        { id: 'vacation', name: "Vacaciones / Incapacidades" }
      ];
      $scope.showInternalDeprecationBanner = !localStorage.getItem('internal_deprecation_banner_dismissed');
      $scope.dismissInternalDeprecationBanner = function () {
        localStorage.setItem('internal_deprecation_banner_dismissed', 'true');
        $scope.showInternalDeprecationBanner = false;
      };
      $scope.currentActivity.description = undefined;
      $scope.modalTittle = "Nueva actividad";
      $scope.currentActivity.favorite = false;
      $scope.selectedCustomer = undefined;
      $scope.searchCustomer = '';
      $scope.selectedProject = undefined;
      $scope.selectedTicket = undefined;
      $scope.searchProject = '';
      $scope.isDisabled = true;
      $scope.startOFWeek = undefined;
      $scope.endOFWeek = undefined;
      $scope.support = false;
      $scope.clearIcon = true;
      $scope.anyErrors = false;
      $scope.oldActivity = undefined;
      $scope.allDaySelected = false;
      $scope.daySelected = undefined;
      $scope.editable = true;
      $scope.selectedEmployee = {
        name: 'Todos',
        id: null
      };
      $scope.searchEmployee = '';
      $scope.selectedTicket = undefined;
      $scope.searchTicket = '';
      $scope.refreshCalendar = false;

      const SCISA_CUSTOMER_ID = 29;

      $scope.actionTypesCatalogsSummary = ActivityTypeCatalog.getActivityTypesCatalogSummary();

      $scope.findActionTypeSummary = function (id) {
        var actionType = $scope.actionTypesCatalogsSummary.find(function (type) {
          return type.id === id;
        });
        return actionType ? actionType.summaryExtendedName : '';
      };
      $scope.findActionTypeSummary = function (id) {
        var actionType = $scope.actionTypesCatalogsSummary.find(function (type) {
          return type.id === id;
        });
        return actionType ? actionType.summaryExtendedName : '';
      };

      $scope.productsAll = []

      $scope.findProductWithID = function (id) {
        var product = $scope.productsAll.find(function (type) {
          return type.id === id;
        });
        return product ? product.name : '';
      }

      var scrollTime = moment().format("HH") + ":00:00";

      $scope.ticketSearch = function (searchQuery) {
        if (!searchQuery) {
          return [];
        }
        var params = {
          'search': searchQuery
        };
        var deferred = $q.defer();
        Activity.getAllTickets(params).then((response) => {
          $scope.tickets = response.data;
          deferred.resolve($scope.tickets);
        }).catch((error) => {
          toaster.pop('error', 'Azure Devops', error.data.error);
          Activity.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      }

      $scope.selectedTicketChange = function (ticket) {
        if (ticket == undefined) {
          $scope.currentActivity.ticketId = null;
          $scope.currentActivity.ticketName = null;
        } else {
          $scope.currentActivity.ticketId = ticket.id;
          $scope.currentActivity.ticketName = ticket.title;
          $scope.currentActivity.description = ticket.title;
        }
      }

      $scope.removeScisaCustomerFromCollection = (collection, currentActivityActionType) => {
        if (collection.length > 0 && $scope.currentActivity.actionType === currentActivityActionType) {
          collection.forEach(item => {
            if (item.id == SCISA_CUSTOMER_ID) {
              var index = collection.indexOf(item);
              collection.splice(index, 1)
            }
          });
        }
        return collection;
      }

      const getDefaultDate = () => {
        var currentDate = moment().subtract(1, "week");
        $scope.downloadStartDate = new Date(currentDate.clone().startOf('isoWeek'))
        $scope.downloadEndDate = new Date(currentDate.clone().endOf('isoWeek'))
        var today = new Date().toISOString().split('T')[0];
        document.getElementById("dateIdStart").setAttribute("max", today);
        document.getElementById("dateIdEnd").setAttribute("max", today);
      }

      // El corazon crea una plantilla con lo capturado. La actividad no se toca.
      $scope.setFavorite = function () {
        if ($scope.currentActivityIsFavorite()) {
          toaster.pop('info', 'Favoritas', 'Esta actividad ya está en tus favoritas');
          return;
        }

        const payload = {
          activity_template: {
            action_type: $scope.currentActivity.actionType,
            description: $scope.currentActivity.description,
            project_id: $scope.currentActivity.projectId,
            ownerable_id: $scope.currentActivity.clientId,
            ownerable_type: $scope.currentActivity.ownerableType,
            product_catalog_id: $scope.currentActivity.productId,
            activity_type_catalog_id: $scope.currentActivity.activityTypeCatalogId,
            ticket_id: $scope.currentActivity.ticketId,
            ticket_name: $scope.currentActivity.ticketName
          }
        };

        cfpLoadingBar.start();
        ActivityTemplate.save(payload).then(() => {
          toaster.pop('success', 'Favoritas', 'Se agregó a tus actividades favoritas');
          loadFavoriteTemplates();
        }).catch((error) => {
          ActivityTemplate.error(error);
        }).finally(() => {
          cfpLoadingBar.complete();
        });
      }

      $scope.downloadButton = () => {
        if ($scope.selectedEmployee != null) {
          var employeeId = $scope.selectedEmployee.id;
        } else {
          var employeeId = null;
        }

        const params = {
          params: {
            by_begins_at: {
              start_date: $scope.downloadStartDate,
              end_date: $scope.downloadEndDate
            },
            by_employee: employeeId,
          }
        };

        let downloadPromise;

        if ($rootScope.userIsAdmin) {
          downloadPromise = Activity.downloadActivities(params);
        } else {
          downloadPromise = Activity.downloadPersonalActivities({
            params: {
              by_begins_at: params.params.by_begins_at
            }
          });
        }

        downloadPromise.then((response) => {
          toaster.pop('success', 'Reporte Actividades', response.data.message);
        }).catch(error => {
          console.error(error);
          toaster.pop('error', 'Actividades', error.data?.messages?.[0] || 'Error al descargar reporte');
        });
      };

      $scope.selectedEmployeeIsCurrentEmployee = function () {
        if ($scope.userhasEmployee()) {
          if (JSON.parse($window.localStorage.apiUser).employee.id == $scope.selectedEmployee.id) {
            return true;
          } else {
            return false;
          }
        }
      }

      $scope.userIsAdmin = function () {
        if ('apiUser' in $window.localStorage) {
          const apiUser = JSON.parse($window.localStorage.apiUser);
          if (apiUser.employee) {
            return apiUser.employee.is_admin_group;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      $scope.userhasEmployee = function () {
        if ('apiUser' in $window.localStorage) {
          const apiUser = JSON.parse($window.localStorage.apiUser);
          if ([undefined, null].includes(apiUser.employee)) {
            return false;
          } else {
            return true;
          }
        } else {
          toaster.pop('error', 'Usuario', 'Ocurrio un error, favor de ponerse en contacto con soporte');
          return false;
        }
      }

      $scope.updateActionType = function () {
        $scope.clearIcon = true;
        $scope.selectedCustomer = undefined;
        $scope.selectedProject = undefined;
        $scope.selectedTicket = undefined;
        $scope.currentActivity.projectId = null;
        $scope.currentActivity.projectName = null;
        $scope.currentActivity.clientId = null;
        $scope.currentActivity.clientName = null;
        $scope.currentActivity.project_code = null;
        $scope.currentActivity.activityTypeCatalogId = null;
        $scope.currentActivity.productId = null;
        $scope.currentActivity.ticketId = null;
        $scope.currentActivity.ticketName = null;
        if ($scope.currentActivity.actionType === 'internal') {
          $scope.clearIcon = false;
          $scope.selectedCustomer = {
            id: sessionStorage.default_customer_id,
            name: sessionStorage.default_customer_name
          }

        } else if ($scope.currentActivity.actionType === 'rh') {
          $scope.clearIcon = false;
          $scope.selectedCustomer = {
            id: sessionStorage.default_customer_id,
            name: sessionStorage.default_customer_name
          }
        } else if ($scope.currentActivity.actionType === 'project') {
          $scope.selectedCustomer = undefined;
          $scope.selectedProject = undefined;
          $scope.clearIcon = false;
        } else if ($scope.currentActivity.actionType === 'vacation') {
          $scope.currentActivity.description = "Vacaciones / Incapacidades"
        }
      }

      $scope.resetActivitySelections = function () {
        $scope.selectedCustomer = undefined;
        $scope.selectedProject = undefined;
        $scope.selectedTicket = undefined;
        $scope.searchCustomer = '';
        $scope.searchProject = '';
        $scope.searchTicket = '';
        $scope.refreshCalendar = false;
        $scope.allDaySelected = false;
      };

      $scope.resetCurrentActivity = function () {
        $scope.currentActivity.actionType = null;
        $scope.currentActivity.description = null;
        $scope.currentActivity.ownerableType = null;
        $scope.currentActivity.activityTypeCatalogId = null;
        $scope.currentActivity.projectId = null;
        $scope.currentActivity.projectName = null;
        $scope.currentActivity.clientId = null;
        $scope.currentActivity.clientName = null;
        $scope.currentActivity.project_code = null;
        $scope.currentActivity.productId = null;
        $scope.currentActivity.ticketId = null;
        $scope.currentActivity.ticketName = null;
        $scope.searchProject = null;
        $scope.searchTicket = null;
        $scope.selectedCustomer = null;
        $scope.clearIcon = true;
      };

      // El selector del modal entrega una plantilla; se convierte a la forma
      // que ya sabe copiar fillWithFavoriteValues.
      $scope.fillWithFavoriteTemplate = function () {
        const template = $scope.currentActivity.favoriteTemplate;
        if (!template) {
          return;
        }
        $scope.currentActivity.favoriteActivity = templateAsFavorite(template);
        $scope.fillWithFavoriteValues();
      };

      $scope.fillWithFavoriteValues = function () {
        let favorite = $scope.currentActivity.favoriteActivity;
        if (favorite) {
          $scope.resetCurrentActivity();

          let action_type = $scope.actionTypes.find(action_type => action_type.id == favorite.action_type);
          $scope.currentActivity.actionType = action_type.id;

          $scope.currentActivity.description = favorite.description;
          $scope.currentActivity.ownerableType = favorite.ownerable_type;
          $scope.currentActivity.activityTypeCatalogId = favorite.activity_type_catalog_id;

          if (action_type.id === "project") {
            $scope.searchProject = favorite.project_name;
            $scope.currentActivity.projectId = favorite.project_id;
            $scope.currentActivity.projectName = favorite.project_name;
            $scope.currentActivity.clientId = favorite.ownerable_id;
            $scope.currentActivity.clientName = favorite.ownerable_name;
            $scope.currentActivity.ownerableType = favorite.ownerable_type;
            $scope.currentActivity.project_code = favorite.project_code;
            $scope.clearIcon = false;
            $scope.selectedCustomer = {
              id: favorite.ownerable_id,
              name: favorite.ownerable_name
            };
          } else if (action_type.id === "support" || action_type.id === "internal" || action_type.id === "rh") {
            $scope.currentActivity.clientId = favorite.ownerable_id;
            $scope.currentActivity.ownerableType = favorite.ownerable_type;
            $scope.selectedCustomer = {
              id: favorite.ownerable_id,
              name: favorite.ownerable_name
            };
            $scope.selectedCustomerChange($scope.selectedCustomer);
            $scope.currentActivity.productId = favorite.product_id;
          } else if (action_type.id === "quote") {
            $scope.currentActivity.clientId = favorite.ownerable_id;
            $scope.currentActivity.ownerableType = favorite.ownerable_type;
            $scope.selectedCustomer = {
              id: favorite.ownerable_id,
              name: favorite.ownerable_name
            };
            validateCustomerAndFilterProducts(favorite.ownerable_id, favorite.ownerable_type);
            $scope.currentActivity.productId = favorite.product_id;
          }

          $scope.currentActivity.ticketId = favorite.ticket_id;
          $scope.currentActivity.ticketName = favorite.ticket_name;
          if (favorite.ticket_id != null) {
            $scope.searchTicket = favorite.ticket_id + ", " + favorite.ticket_name;
          } else {
            $scope.searchTicket = "";
          }
        }
      };

      $scope.selectedCustomerOrProspectChange = (customerOrProspect) => {
        if (customerOrProspect == undefined) {
          $scope.currentActivity.clientId = undefined;
          $scope.currentActivity.ownerableType = undefined;
        } else if (customerOrProspect.search_type === "Client") {
          $scope.currentActivity.clientId = customerOrProspect.id;
          $scope.currentActivity.ownerableType = "Client";
          validateCustomerAndFilterProducts(customerOrProspect.id, "Client");
        } else if (customerOrProspect.search_type === "Prospect") {
          $scope.currentActivity.clientId = customerOrProspect.id;
          $scope.currentActivity.ownerableType = "Prospect";
          validateCustomerAndFilterProducts(customerOrProspect.id, "Prospect");
        }
      };


      $scope.employeeSearch = (searchQuery) => {
        if (!searchQuery) {
          return [];
        }
        var employeeParams = {
          'params': {
            'search': searchQuery
          }
        };
        var deferred = $q.defer();
        var allEmployees = {
          name: "Todos",
          id: null
        };
        Employee.index(employeeParams).then((response) => {
          let response_data = response.data.employees;
          response_data.unshift(allEmployees)
          deferred.resolve(response_data);
        }).catch((error) => {
          Employee.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      if ('apiUser' in $window.localStorage) {
        $scope.employeeId = JSON.parse($window.localStorage.apiUser).employee;
        if ($scope.userIsAdmin() === false) {
          $scope.selectedEmployee = $scope.employeeId
        }
      }

      $scope.selectedEmployeeChange = (employee) => {
        if (employee != undefined) {
          if (employee.id != null) {
            $scope.currentEmployee.employeeId = employee.id
            $scope.viewObject.calendar.refetchEvents();
          }
        } else {
          $scope.viewObject.calendar.refetchEvents();
        }
      }

      $scope.customerOrProspectSearch = (searchQuery) => {
        if (!searchQuery) {
          return [];
        }
        var customerOrProspectParams = {
          'params': {
            'search': searchQuery
          }
        };
        var deferred = $q.defer();
        SearchClientsAndProspects.index(customerOrProspectParams).then((response) => {
          let clients_prospects = [];
          let response_data = $scope.removeScisaCustomerFromCollection(response.data, "quote");
          response_data[0].map(item => {
            clients_prospects.push(item)
          })
          response_data[1].map(item => {
            clients_prospects.push(item);
          })
          deferred.resolve(clients_prospects);
        }).catch((error) => {
          Client.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };


      $scope.selectedCustomerChange = (customer) => {
        if (customer == undefined || customer == null) {
          $scope.currentActivity.clientId = undefined;
          $scope.currentActivity.ownerableType = undefined;
        } else {
          if ($scope.currentActivity.actionType === "support") {
            $scope.currentActivity.clientId = customer.id;
            $scope.currentActivity.ownerableType = "Client";
            validateCustomerAndFilterProducts(customer.id, "Client");
          } else {
            if ($scope.currentActivity.actionType == 'rh' || $scope.currentActivity.actionType == 'internal') {
              $scope.currentActivity.clientId = customer.id;
              $scope.currentActivity.ownerableType = "Client";
            }
          }
        }
      };

      let lastToasterTime = 0;
      const toasterDelay = 2500;

      const validateCustomerAndFilterProducts = async (customer, type) => {
        if (customer) {
          if (type !== "Client") {
            filterProducts([], "Prospect");
          } else {
            try {
              const response = await Client.find(customer);
              customer = response.data.client;
            } catch (error) {
              console.error("Error fetching data:", error);
            }
            if (customer.client_product_catalogs.length === 0) {
              const now = Date.now();
              if (now - lastToasterTime >= toasterDelay) {
                toaster.pop('error', 'Actividad', "Se tienen que configurar los productos del cliente");
                lastToasterTime = now;
              }
              filterProducts([], customer.ownerable_type);
            } else if (customer.client_product_catalogs.length > 0) {
              let customerProducts = customer.client_product_catalogs.map(productCatalog => productCatalog.product_catalog_id)
              filterProducts(customerProducts, customer.ownerable_type);
            }
          }
        }
      };

      // $scope.recentActivities ya viene del API ordenado de más a menos reciente,
      // así que la posición en el arreglo sirve como antigüedad.
      const recencyRanks = (field) => {
        const ranks = {};
        ($scope.recentActivities || []).forEach((activity, position) => {
          const id = activity[field];
          if (id != null && ranks[id] === undefined) {
            ranks[id] = position;
          }
        });
        return ranks;
      };

      // Adelanta lo reciente sin descartar nada. El resto conserva el orden del API.
      const byRecencyFirst = (items, field, ranks) => {
        return (items || []).slice().sort((a, b) => {
          const rankA = ranks[a[field]];
          const rankB = ranks[b[field]];
          if (rankA === undefined && rankB === undefined) return 0;
          if (rankA === undefined) return 1;
          if (rankB === undefined) return -1;
          return rankA - rankB;
        });
      };

      $scope.customerSearch = (searchQuery) => {
        if (!searchQuery) {
          return [];
        }
        var customerParams = {
          'params': {
            'search': searchQuery
          }
        };
        var deferred = $q.defer();
        Client.index(customerParams).then((response) => {
          let response_data = $scope.removeScisaCustomerFromCollection(response.data.clients, "support");
          deferred.resolve(byRecencyFirst(response_data, 'id', recencyRanks('ownerable_id')));
        }).catch((error) => {
          Client.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };


      $scope.selectedProjectChange = (project) => {
        if (project === undefined) {
          $scope.selectedCustomer = undefined;
          $scope.selectedProject = undefined;
          $scope.currentActivity.projectId = undefined;
          $scope.currentActivity.projectName = undefined;
          $scope.currentActivity.clientId = undefined;
          $scope.currentActivity.clientName = undefined;
          $scope.currentActivity.ownerableType = undefined;
          $scope.currentActivity.project_code = undefined;
        } else {
          $scope.currentActivity.projectId = project.id
          $scope.currentActivity.projectName = project.name
          $scope.currentActivity.clientId = project.client_id
          $scope.currentActivity.clientName = project.client_name
          $scope.currentActivity.ownerableType = "Client"
          $scope.currentActivity.project_code = project.project_code
          $scope.clearIcon = false;
          $scope.selectedCustomer = {
            id: project.client_id,
            name: project.client_name
          }
        }
      }

      $scope.projectSearch = (searchQuery) => {
        return Project.searchWithCache(searchQuery, true).then((projects) => {
          return byRecencyFirst(projects, 'id', recencyRanks('project_id'));
        });
      };

      // Descripciones ya usadas, de la más reciente a la más antigua, sin repetir.
      const buildRecentDescriptions = () => {
        const seen = {};
        $scope.recentDescriptions = ($scope.recentActivities || []).reduce((list, activity) => {
          const text = (activity.description || '').trim();
          if (text && !seen[text]) {
            seen[text] = true;
            list.push(text);
          }
          return list;
        }, []);
      };

      // Los pendientes todavia no son actividades: nada que los arrastre o
      // redimensione debe guardarlos contra el API.
      const isPendingImport = (event) => !!(event && event.isPendingImport);

      $scope.eventDragStart = (selectedActivity, jsEvent, ui, view) => {
        $scope.draggingIcon = selectedActivity.isCopy === true;
        if (selectedActivity.ticket_id == null) {
          $scope.selectedTicket = undefined
        }
        if ($scope.draggingIcon) {
          $scope.oldActivity = selectedActivity;
          if (selectedActivity.is_favorite) {
            $scope.oldActivity.is_favorite = false;
          }
        } else {
          $scope.oldActivity = undefined;
        }
      }

      $scope.eventDrop = (selectedActivity, delta, reverFunc, jsEvent, ui, view) => {
        if (isPendingImport(selectedActivity)) {
          reschedulePending(selectedActivity, view);
          return;
        }

        if (selectedActivity.ticket_id === null) {
          $scope.selectedTicket = undefined;
        }

        if (selectedActivity.allDay) {
          reverFunc();
          toaster.pop('warning', 'Actividad', 'Se necesita crear la actividad dando click en la casilla "todo el dia" o duplicarla arrastrándola del icono.');
          return;
        }

        parseCurrentActivity(selectedActivity);

        if (selectedActivity.isCopy === true || $scope.draggingIcon) {
          $scope.currentActivity.id = 0;
          let newActivity = parseSaveActivity();
          Activity.save({ activity: newActivity }).then((response) => {
            toaster.pop('success', 'Actividad', 'La actividad se copió correctamente');
            selectedActivity.allDay = false;
          }).catch((error) => {
            console.error(error);
            toaster.pop('error', 'Actividad', error.data.errors.base);
          }).finally(() => {
            view.calendar.refetchEvents();
            resetFormState();
            selectedActivity.isCopy = false;
            $scope.draggingIcon = false;
          });
        } else {
          let newActivity = parseSaveActivity();
          cfpLoadingBar.start();

          Activity.save({ activity: newActivity }).then((response) => {
            parseActivity(response.data, selectedActivity);
            view.calendar.updateEvent(selectedActivity);
            view.calendar.refetchEvents();
            toaster.pop('success', 'Actividad', 'La actividad se editó correctamente');
          }).catch((error) => {
            console.error(error);
            toaster.pop('error', 'Actividad', error.data.errors.base);
            view.calendar.refetchEvents();
          }).finally(() => {
            resetFormState();
            cfpLoadingBar.complete();
            $scope.draggingIcon = false;
          });
        }
      };

      function resetFormState() {
        $scope.currentActivity = {};
        $scope.currentActivity.description = undefined;
        $scope.selectedCustomer = undefined;
        $scope.selectedProject = undefined;
        $scope.refreshCalendar = false;
        $scope.selectedTicket = undefined;
      }

      let draftInitial = null;
      let draftMode = null;
      let draftActivityId = null;
      let stopDraftWatch = null;
      let draftSession = 0;

      const draftOwner = () => {
        try {
          const apiUser = JSON.parse($window.localStorage.apiUser);
          return apiUser && apiUser.employee ? apiUser.employee.id : null;
        } catch (error) {
          return null;
        }
      };

      const currentDraftData = () => ActivityDraft.snapshot($scope.currentActivity, {
        customer: $scope.selectedCustomer,
        project: $scope.selectedProject,
        ticket: $scope.selectedTicket
      });

      const formHasChanges = () => draftInitial !== null && ActivityDraft.isDirty(draftInitial, currentDraftData());

      const warnBeforeUnload = (event) => {
        if (formHasChanges()) {
          event.preventDefault();
          event.returnValue = '';
        }
      };

      const startDraftTracking = () => {
        const session = draftSession;
        $timeout(() => {
          if (session !== draftSession) {
            return;
          }
          draftMode = $scope.editOrCreate;
          draftActivityId = $scope.currentActivity ? $scope.currentActivity.id : null;
          draftInitial = currentDraftData();

          const pending = ActivityDraft.load(draftOwner());
          $scope.draftOffer = $scope.isEditable && ActivityDraft.matches(pending, draftMode, draftActivityId) ? pending : null;

          stopDraftWatch = $scope.$watch(currentDraftData, (data) => {
            if (draftInitial === null || !ActivityDraft.isDirty(draftInitial, data)) {
              return;
            }
            $scope.draftOffer = null;
            ActivityDraft.save(draftOwner(), {
              mode: draftMode,
              activityId: draftActivityId,
              savedAt: new Date().toISOString(),
              data: data
            });
          }, true);

          $window.addEventListener('beforeunload', warnBeforeUnload);
        });
      };

      const stopDraftTracking = () => {
        draftSession++;
        if (stopDraftWatch) {
          stopDraftWatch();
          stopDraftWatch = null;
        }
        draftInitial = null;
        $scope.draftOffer = null;
        $scope.exitWarning = false;
        $window.removeEventListener('beforeunload', warnBeforeUnload);
      };

      // Solo se borra el borrador del formulario en cuestion: el espacio es uno por empleado.
      const clearDraftIfMatches = (mode, activityId) => {
        if (ActivityDraft.matches(ActivityDraft.load(draftOwner()), mode, activityId)) {
          ActivityDraft.clear(draftOwner());
        }
      };

      const discardDraft = () => {
        clearDraftIfMatches(draftMode, draftActivityId);
        stopDraftTracking();
      };

      $scope.$on('$destroy', stopDraftTracking);

      $scope.recoverDraft = () => {
        const draft = $scope.draftOffer;
        if (!draft) {
          return;
        }
        const data = draft.data;
        $scope.draftOffer = null;
        $scope.selectedCustomer = data.selectedCustomer || undefined;
        $scope.selectedProject = data.selectedProject || undefined;
        $scope.selectedTicket = data.selectedTicket || undefined;

        // Los selectores reescriben campos al cambiar, asi que los valores del borrador se aplican despues.
        $timeout(() => {
          Object.keys(data).forEach((field) => {
            if (field.indexOf('selected') !== 0 && field !== 'startDate' && field !== 'endDate') {
              $scope.currentActivity[field] = data[field];
            }
          });
          if (data.startDate) {
            $scope.currentActivity.startDate = new Date(data.startDate);
          }
          if (data.endDate) {
            $scope.currentActivity.endDate = new Date(data.endDate);
          }
          if ((data.actionType === 'support' || data.actionType === 'quote') && data.clientId) {
            validateCustomerAndFilterProducts(data.clientId, data.ownerableType);
          }
        });
      };

      $scope.discardDraftOffer = () => {
        $scope.draftOffer = null;
        ActivityDraft.clear(draftOwner());
      };

      $scope.onActivityDialogKeydown = (event) => {
        if (event.keyCode === 27) {
          event.preventDefault();
          $scope.cancel();
        }
      };

      $scope.openActivity = (selectedActivity) => {
        $scope.editOrCreate = "edit"
        $scope.modalTittle = "Editar actividad"
        parseCurrentActivity(selectedActivity)
        $scope.isDisabled = false;
        $scope.DisabledCopy = true;
        $scope.newCurrentActivity = selectedActivity;
        if (selectedActivity.action_type === "support" || selectedActivity.action_type === "quote") {
          validateCustomerAndFilterProducts($scope.newCurrentActivity.ownerable_id, $scope.newCurrentActivity.ownerable_type)
        }
        $scope.isEditable = true
        var currentScrollPosition = window.scrollY;
        $mdDialog.show({
          clickOutsideToClose: false,
          escapeToClose: false,
          controller: $scope.SaveActivityCtrl,
          templateUrl: 'views/activities/_new-activity-modal.html',
          scope: $scope,
          preserveScope: true,
          onComplete: startDraftTracking,
          onRemoving: function () {
            stopDraftTracking();
            window.scrollTo(0, currentScrollPosition);
          }
        }).then(() => {
          // Save the activity
          let newActivity = parseSaveActivity()
          cfpLoadingBar.start();
          Activity.save({ activity: newActivity }).then((response) => {
            parseActivity(response.data, selectedActivity)
            clearDraftIfMatches('edit', selectedActivity.id);
            toaster.pop('success', 'Actividad', 'La actividad se edito correctamente');
          }).catch(error => {
            console.error(error);
            if (error.data.errors.hasOwnProperty('description')) {
              toaster.pop('error', 'Actividad', error.data.errors.description[0]);
            } else {
              toaster.pop('error', 'Actividad', error.data.errors.base[0]);
            }
          }).finally(() => {
            cfpLoadingBar.complete()
            $scope.currentActivity = {};
          })
          $scope.currentActivity.description = undefined;
          $scope.resetActivitySelections();
        }).catch(() => {
        })
      };

      $scope.eventClick = (selectedActivity, jsEvent, view) => {
        if (isPendingImport(selectedActivity)) {
          if (jsEvent.target.closest('.pending-import-discard')) {
            $scope.discardPending(selectedActivity);
            return;
          }
          classifyPending(selectedActivity, view);
          return;
        }

        if (selectedActivity.ticket_id == null) {
          $scope.selectedTicket = undefined
        }
        $scope.viewObject = view;
        if (jsEvent.target.id === 'copy') {
          window.alert("Se necesita arrastrar la actividad para poder duplicarla")
        } else {
          $scope.editOrCreate = "edit"
          $scope.modalTittle = "Editar actividad"
          parseCurrentActivity(selectedActivity)
          $scope.isDisabled = false;
          $scope.newCurrentActivity = selectedActivity;
          $scope.isEditable = $scope.userIsAdmin() == true ? true : selectedActivity.editable;
          if (selectedActivity.action_type === "support" || selectedActivity.action_type === "quote") {
            validateCustomerAndFilterProducts($scope.newCurrentActivity.ownerable_id, $scope.newCurrentActivity.ownerable_type)
          }

          $scope.DisabledCopy = selectedActivity.editable;

          $scope.copyPrevious = (id) => {
            Activity.copyPreviousWeek({ id_previous_week: id }).then((response) => {
              parseActivity(response.data)
              view.calendar.refetchEvents()
              toaster.pop('success', 'Actividad', 'La actividad se copio correctamente');
              $mdDialog.cancel();
            }).catch(error => {
              toaster.pop('error', 'Actividad', error.data.errors.base[0]);
              view.calendar.refetchEvents();
            }).finally(() => {
              cfpLoadingBar.complete()
            })
          }

          var currentScrollPosition = window.scrollY;
          $mdDialog.show({
            clickOutsideToClose: false,
            escapeToClose: false,
            controller: $scope.SaveActivityCtrl,
            templateUrl: 'views/activities/_new-activity-modal.html',
            scope: $scope,
            preserveScope: true,
            onComplete: startDraftTracking,
            onRemoving: function () {
              stopDraftTracking();
              window.scrollTo(0, currentScrollPosition);
            }
          }).then(() => {
            // Save the activity
            let newActivity = {}
            if (selectedActivity.editable) {
              newActivity = parseSaveActivity()
            } else {
              const apiUser = JSON.parse($window.localStorage.apiUser);
              if (apiUser.employee) {
                let idAdmin = apiUser.employee.id;
                newActivity = parseSaveActivity(idAdmin)
              } else {
                newActivity = parseSaveActivity()
                toaster.pop('error', 'Actividad', "El usuario no tiene un empleado asignado");
              }
            }
            cfpLoadingBar.start();
            Activity.save({ activity: newActivity }).then((response) => {
              parseActivity(response.data, selectedActivity)
              clearDraftIfMatches('edit', selectedActivity.id);
              view.calendar.updateEvent(selectedActivity);
              view.calendar.refetchEvents()
              toaster.pop('success', 'Actividad', 'La actividad se edito correctamente');
            }).catch(error => {
              console.error(error);
              if (error.data.errors.hasOwnProperty('description')) {
                toaster.pop('error', 'Actividad', error.data.errors.description[0]);
              } else {
                toaster.pop('error', 'Actividad', error.data.errors.base[0]);
              }
              view.calendar.refetchEvents();
            }).finally(() => {
              cfpLoadingBar.complete()
              $scope.currentActivity = {};
            })
            $scope.currentActivity.description = undefined;
            $scope.resetActivitySelections();
          }).catch(() => {
          })
        }
      }

      $scope.alertOnResize = (selectedActivity, delta, revertFunc, jsEvent, ui, view) => {
        if (isPendingImport(selectedActivity)) {
          reschedulePending(selectedActivity, view);
          return;
        }

        if (selectedActivity.ticket_id == null) {
          $scope.selectedTicket = undefined
        }
        parseCurrentActivity(selectedActivity)
        let newActivity = parseSaveActivity()
        cfpLoadingBar.start()
        Activity.save({ activity: newActivity }).then((response) => {
          parseActivity(response.data, selectedActivity)
          view.calendar.updateEvent(selectedActivity);
          toaster.pop('success', 'Actividad', 'La actividad se edito correctamente');
        }).catch(error => {
          console.error(error);
          toaster.pop('error', 'Actividad', error.data.errors.base);
          view.calendar.refetchEvents();
        }).finally(() => {
          cfpLoadingBar.complete()
          $scope.currentActivity = {}
          $scope.currentActivity.description = undefined;
          $scope.resetActivitySelections();
        })
      }

      $scope.SaveActivityCtrl = ['$scope', function ($scope) {
        $scope.activityHash = {};
        $scope.save = function () {
          if ($scope.editOrCreate == "edit") {
            stopDraftTracking();
            $mdDialog.hide();
          } else if ($scope.editOrCreate == "create") {
            saveActTest().then(() => {
              if ($scope.anyErrors) {
              } else {
                discardDraft();
                $scope.refreshCalendar = true;
                $mdDialog.hide();
              }
            });
          }
        };
        $scope.cancel = function () {
          if (!formHasChanges()) {
            $scope.refreshCalendar = false;
            $mdDialog.cancel();
            return;
          }
          $scope.exitWarning = true;
        };
        $scope.keepEditing = function () {
          $scope.exitWarning = false;
        };
        $scope.confirmExit = function () {
          discardDraft();
          $scope.refreshCalendar = false;
          $mdDialog.cancel();
        };
        $scope.delete = function () {
          discardDraft();
          $mdDialog.delete();
          $mdDialog.cancel();
        };
      }];

      $mdDialog.delete = () => {
        Activity.delete($scope.newCurrentActivity.id).then(function (response) {
          toaster.pop('success', 'Actividad', 'La actividad se elimino correctamente');
          $scope.viewObject.calendar.refetchEvents();
        }, function (error) {
          Activity.error(error);
        });
      }

      $scope.select = (startDate, endDate, jsEvent, view) => {

        $scope.products = [];
        $scope.editOrCreate = "create"
        $scope.isEditable = true;
        $scope.modalTittle = "Nueva actividad"
        var day = startDate.format('YYYY-MM-DD')
        if ($scope.allDaySelected) {
          var startTime = "09:00";
          var endTime = "18:00";
          $scope.currentActivity = {
            id: 0,
            startDate: new Date(moment(day + ' ' + startTime)),
            endDate: new Date(moment(day + ' ' + endTime)),
            currentDay: startDate.format('YYYY-MM-DD'),
            actionType: $scope.actionTypes[0].id
          };
        } else {
          $scope.currentActivity = {
            id: 0,
            startDate: new Date(startDate),
            endDate: new Date(endDate),
            currentDay: startDate.format('YYYY-MM-DD'),
            actionType: $scope.actionTypes[0].id
          };
        }
        $scope.isDisabled = true;
        $scope.DisabledCopy = true;
        var currentScrollPosition = window.scrollY;
        $mdDialog.show({
          clickOutsideToClose: false,
          escapeToClose: false,
          controller: $scope.SaveActivityCtrl,
          templateUrl: 'views/activities/_new-activity-modal.html',
          scope: $scope,
          preserveScope: true,
          onComplete: startDraftTracking,
          onRemoving: function () {
            stopDraftTracking();
            window.scrollTo(0, currentScrollPosition);
          }
        }).catch(() => {
        }).finally(() => {
          if ($scope.refreshCalendar) {
            view.calendar.refetchEvents();
          }
          $scope.refreshCalendar = false;
          $scope.currentActivity = {};
        });
        $scope.currentActivity.description = undefined;
        $scope.resetActivitySelections();

        if ($scope.armedFavorite) {
          applyArmedFavorite(startDate, endDate);
        }
      }

      // Un clic sin arrastre selecciona un hueco de 15 minutos; la favorita abre con una hora.
      const applyArmedFavorite = (startDate, endDate) => {
        if (endDate.diff(startDate, 'minutes') <= 15) {
          $scope.currentActivity.endDate = new Date(startDate.clone().add(1, 'hours'));
        }
        $scope.currentActivity.favoriteActivity = templateAsFavorite($scope.armedFavorite);
        $scope.fillWithFavoriteValues();
      };

      const saveActTest = async () => {
        $scope.anyErrors = false;
        let newActivity = parseSaveActivity()
        cfpLoadingBar.start();
        await Activity.save({ activity: newActivity }).then((response) => {
          toaster.pop('success', 'Actividad', 'La actividad se creo correctamente');
          registerArmedFavoriteUse();
        }).catch(error => {
          if ('errors' in error.data) {
            let errors = error.data.errors
            Object.keys(errors).map(e => {
              errors[e].map(r => {
                let errorString = `${e} ${r}`
                toaster.pop('error', 'Actividad', errorString);
              })
            })
          } else {
            toaster.pop('error', 'Actividad', error.data.error);
          }
          $scope.anyErrors = true;
        }).finally(() => {
          cfpLoadingBar.complete();
        });
        return $scope.anyErrors
      }

      const getCatalogParmas = () => {
        const ActivityTypeCatalogsPromise = ActivityTypeCatalog.index({
          params: {
            per_page: "all"
          }
        }).then((response) => {
          $scope.activityTypeCatalogs = response.data.activity_type_catalogs;
        }).catch(error => {
          console.error(error);
        });

        const getProducts = ProductCatalog.index({ params: { per_page: "all" } }).then((response) => {
          $scope.productsAll = response.data.products;
          var res = response.data.products;
          $scope.productsUnfiltered = res.filter(data => data.name != 'SIA' && data.name != 'Framework' && data.name != 'SICAJAS');
        })
          .catch(error => {
            console.error(error);
          });

        return Promise.all([ActivityTypeCatalogsPromise, getProducts]);
      }

      const filterProducts = (customerProducts, type) => {
        if (type === "Prospect") {
          $scope.products = $scope.productsUnfiltered;
        } else {
          $scope.products = $scope.productsUnfiltered.filter(data => customerProducts.includes(data.id));
        }
      }

      function checkFrozenMonth(activities) {
        const list = Array.isArray(activities) ? activities : [];
        // La respuesta no trae orden, asi que se toma la congelada mas antigua.
        const frozen = list
          .filter(a => a && a.is_month_frozen === true)
          .sort((a, b) => new Date(a.begins_at) - new Date(b.begins_at))[0];

        if (frozen) {
          const d = new Date(frozen.begins_at);
          $scope.isMonthLocked = true;
          $scope.lockedMonthName = d.toLocaleString('es-MX', { month: 'long', year: 'numeric' });
          $scope.lockedMonthDate = d;
        } else {
          $scope.isMonthLocked = false;
          $scope.lockedMonthName = '';
          $scope.lockedMonthDate = null;
        }

        return $scope.isMonthLocked;
      }

      const getActivities = (startOFWeek, endOFWeek) => {
        if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
          var selectedEmployeeId = $scope.selectedEmployee.id;
        } else {
          var selectedEmployeeId = JSON.parse(window.localStorage.apiUser).employee.id;
        }
        if ($scope.userhasEmployee()) {
          cfpLoadingBar.start();
          return Activity.getWeekActivities(selectedEmployeeId, startOFWeek, endOFWeek).then((response) => {
            checkFrozenMonth(response.data.activities);
            $scope.editable = true;
            try {
              return response.data.activities.map(activityRes => {
                let activity = parseActivity(activityRes)
                $scope.activities.push(activity)
                if (!activityRes.is_editable) {
                  $scope.editable = false;
                }
                return activity;
              });
            } catch (parseError) {
              console.error(parseError);
              $scope.activities = [];
              toaster.pop('error', 'Actividades', 'Una actividad tiene datos incompletos. Contacte a soporte.');
            }
          }).catch(error => {
            console.error(error);
            $scope.activities = [];
            // Sin esto el aviso de mes bloqueado se queda del cargado anterior.
            checkFrozenMonth([]);
            toaster.pop('error', 'Actividades', 'Error al cargar las actividades. Intente de nuevo.');
          }).finally(() => {
            cfpLoadingBar.complete();
          });
        } else {
          toaster.pop('error', 'Empleado', 'Favor de ponerse en contacto con RH para que lo den de alta como empleado');
          return false
        }
      }

      const parseActivity = (activity, newActivity = {}) => {
        activity.ownerable = activity.ownerable || { id: null, name: null }
        newActivity.id = activity.id
        newActivity.title = activity.title
        newActivity.start = moment(activity.begins_at).format('YYYY-MM-DD hh:mm a')
        newActivity.end = moment(activity.ends_at).format('YYYY-MM-DD hh:mm a')
        newActivity.action_type = activity.action_type
        // El modo de importacion lo necesita para no duplicar lo ya importado.
        newActivity.google_calendar_id = activity.google_calendar_id

        if (activity.action_type === "internal") {
          newActivity.description = activity.description
          newActivity.activity_type_catalog_id = activity.activity_type_catalog_id
          newActivity.ownerable_id = Number(sessionStorage.default_customer_id)
          newActivity.ownerable_name = sessionStorage.default_customer_name
          newActivity.ownerable_type = activity.ownerable_type
        } else if (activity.action_type === "rh") {
          newActivity.description = activity.description
          newActivity.ownerable_id = Number(sessionStorage.default_customer_id)
          newActivity.ownerable_name = sessionStorage.default_customer_name
          newActivity.ownerable_type = activity.ownerable_type
        } else if (activity.action_type === "vacation") {
          newActivity.description = "Vacaciones / Incapacidades"
          newActivity.ownerable_type = null
        } else {
          newActivity.description = activity.description
          newActivity.activity_type_catalog_id = activity.activity_type_catalog_id
          newActivity.ownerable_id = activity.ownerable.id
          newActivity.ownerable_name = activity.ownerable.name
          newActivity.ownerable_type = activity.ownerable_type
          newActivity.project_id = activity.project_id
          newActivity.product_id = activity.product_catalog_id
          newActivity.ticket_id = activity.ticket_id
          newActivity.ticket_name = activity.ticket_name
        }

        if (activity.action_type === "project") {
          newActivity.project_name = activity.project.name
          newActivity.ownerable_name = activity.ownerable.name
          newActivity.project_code = activity.project.project_code
          newActivity.short_title = activity.title
          newActivity.color_tag = activity.project.color_tag
        }

        newActivity.is_favorite = activity.is_favorite

        return newActivity
      }

      const parseSaveActivity = (idAdmin) => {
        if (sessionStorage.default_customer_id == undefined) {
          AppSetting.getAppSettings();
        }

        let ownerable_id = $scope.currentActivity.clientId;
        if ($scope.currentActivity.actionType == 'vacation') {
          ownerable_id = null;
          $scope.currentActivity.ownerableType = null;
        }
        return {
          id: $scope.currentActivity.id,
          begins_at: $scope.currentActivity.startDate,
          ends_at: $scope.currentActivity.endDate,
          description: $scope.currentActivity.description,
          activity_type_catalog_id: $scope.currentActivity.activityTypeCatalogId,
          action_type: $scope.currentActivity.actionType,
          ownerable_id: ownerable_id,
          ownerable_type: $scope.currentActivity.ownerableType,
          project_id: $scope.currentActivity.projectId,
          project_code: $scope.currentActivity.projectCode,
          product_catalog_id: $scope.currentActivity.productId,
          short_title: $scope.currentActivity.shortTitle,
          ticket_id: $scope.currentActivity.ticketId,
          ticket_name: $scope.currentActivity.ticketName,
          is_favorite: $scope.currentActivity.favorite,
          update_by: idAdmin ? idAdmin : null,
        };
      }

      const parseCurrentActivity = (selectedActivity) => {
        if (selectedActivity.action_type === "internal") {
          $scope.currentActivity = {
            id: selectedActivity.id,
            startDate: new Date(selectedActivity.start),
            endDate: new Date(selectedActivity.end),
            description: selectedActivity.description,
            clientId: Number(sessionStorage.default_customer_id),
            ownerableType: selectedActivity.ownerable_type,
            activityTypeCatalogId: selectedActivity.activity_type_catalog_id,
            actionType: selectedActivity.action_type,
            shortTitle: selectedActivity.short_title
          }
          $scope.selectedCustomer = {
            id: sessionStorage.default_customer_id,
            name: sessionStorage.default_customer_name
          }
        } else if (selectedActivity.action_type === "rh") {
          $scope.currentActivity = {
            id: selectedActivity.id,
            startDate: new Date(selectedActivity.start),
            endDate: new Date(selectedActivity.end),
            description: selectedActivity.description,
            clientId: Number(sessionStorage.default_customer_id),
            ownerableType: selectedActivity.ownerable_type,
            actionType: selectedActivity.action_type,
            shortTitle: selectedActivity.short_title
          }
          $scope.selectedCustomer = {
            id: sessionStorage.default_customer_id,
            name: sessionStorage.default_customer_name
          }
        } else if (selectedActivity.action_type === "vacation") {
          $scope.currentActivity = {
            id: selectedActivity.id,
            startDate: new Date(selectedActivity.start),
            endDate: new Date(selectedActivity.end),
            actionType: selectedActivity.action_type,
            description: "Vacaciones / Incapacidades",
            shortTitle: selectedActivity.short_title
          }
        } else {
          $scope.currentActivity = {
            id: selectedActivity.id,
            startDate: new Date(selectedActivity.start),
            endDate: new Date(selectedActivity.end),
            description: selectedActivity.description,
            clientId: selectedActivity.ownerable_id,
            ownerableType: selectedActivity.ownerable_type,
            activityTypeCatalogId: selectedActivity.activity_type_catalog_id,
            actionType: selectedActivity.action_type,
            projectId: selectedActivity.project_id,
            projectCode: selectedActivity.project_code,
            productId: selectedActivity.product_id,
            shortTitle: selectedActivity.short_title,
            ticketId: selectedActivity.ticket_id,
            ticketName: selectedActivity.ticket_name
          }

          $scope.selectedCustomer = {
            id: selectedActivity.ownerable_id,
            name: selectedActivity.ownerable_name
          }
        }

        if (selectedActivity.action_type === "project") {
          $scope.selectedProject = {
            id: selectedActivity.project_id,
            name: selectedActivity.project_name,
            client_id: selectedActivity.ownerable_id,
            client_name: selectedActivity.ownerable_name,
            code: selectedActivity.project_code
          }
        }

        if ((selectedActivity.action_type == "support" || selectedActivity.action_type === "project") && selectedActivity.ticket_id != null) {
          $scope.selectedTicket = {
            id: selectedActivity.ticket_id,
            title: selectedActivity.ticket_name
          }
        }

        $scope.currentActivity.currentDay = moment(new Date(selectedActivity.start)).format("YYYY-MM-DD");
        $scope.currentActivity.favorite = selectedActivity.is_favorite
      }

      const DAY_OF_WEEK_CLASS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

      const paintHolydayColumns = () => {
        ($scope.activity_holydays || []).forEach(holyday => {
          var parts = holyday.dates.split('/')
          var holydayDate = new Date(parts[2], parts[1] - 1, parts[0])
          var dayClass = 'fc-' + DAY_OF_WEEK_CLASS[holydayDate.getDay()]
          var elements = document.getElementsByClassName(dayClass)
          for (var i = 0; i < elements.length; i++) {
            elements[i].style.backgroundColor = "#eefdec";
          }
        })
      }

      const getWeekHolydays = (startOfWeek, endOfWeek) => {
        Holyday.index({
          params: {
            holydays_by_date: {
              start_date: startOfWeek,
              end_date: endOfWeek
            }
          }
        }).then(function (response) {
          $scope.activity_holydays = response.data.holydays
          paintHolydayColumns()
        }).catch(error => {
          console.error(error);
        });
      }

      const getRecentActivities = () => {
        if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
          var selectedEmployeeId = $scope.selectedEmployee.id;
        } else {
          var selectedEmployeeId = JSON.parse(window.localStorage.apiUser).employee.id;
        }
        if ($scope.userhasEmployee()) {
          cfpLoadingBar.start();
          return Activity.recentActivities({
            params: {
              employee_id: selectedEmployeeId,
            }
          }).then((response) => {
            $scope.recentActivities = response.data.activities.map(activityRes => {
              let activity = parseActivity(activityRes)
              return activity;
            });
            buildRecentDescriptions();
          });
        } else {
          toaster.pop('error', 'Empleado', 'Favor de ponerse en contacto con RH para que lo den de alta como empleado');
          return false
        }
      }

      $scope.fillWithRecentValues = function () {
        let recent = $scope.currentActivity.recentActivity;
        if (recent) {
          let typedDescription = $scope.currentActivity.description;
          $scope.resetCurrentActivity();

          let action_type = $scope.actionTypes.find(action_type => action_type.id == recent.action_type);
          $scope.currentActivity.actionType = action_type.id;

          $scope.currentActivity.description = (typedDescription || '').trim() ? typedDescription : recent.description;
          $scope.currentActivity.ownerableType = recent.ownerable_type;
          $scope.currentActivity.activityTypeCatalogId = recent.activity_type_catalog_id;

          if (action_type.id === "project") {
            $scope.searchProject = recent.project_name;
            $scope.currentActivity.projectId = recent.project_id;
            $scope.currentActivity.projectName = recent.project_name
            $scope.currentActivity.clientId = recent.ownerable_id
            $scope.currentActivity.clientName = recent.ownerable_name
            $scope.currentActivity.ownerableType = recent.ownerable_type
            $scope.currentActivity.project_code = recent.project_code
            $scope.clearIcon = false;
            $scope.selectedCustomer = {
              id: recent.ownerable_id,
              name: recent.ownerable_name
            }
          }
          else if (action_type.id === "support" || action_type.id === "internal" || action_type.id === "rh") {
            $scope.currentActivity.clientId = recent.ownerable_id;
            $scope.currentActivity.ownerableType = recent.ownerable_type;
            $scope.selectedCustomer = {
              id: recent.ownerable_id,
              name: recent.ownerable_name
            }
            $scope.selectedCustomerChange($scope.selectedCustomer);
            $scope.currentActivity.productId = recent.product_id;

          } else if (action_type.id === "quote") {
            $scope.currentActivity.clientId = recent.ownerable_id;
            $scope.currentActivity.ownerableType = recent.ownerable_type;
            $scope.selectedCustomer = {
              id: recent.ownerable_id,
              name: recent.ownerable_name
            }
            validateCustomerAndFilterProducts(recent.ownerable_id, recent.ownerable_type);
            $scope.currentActivity.productId = recent.product_id;
          }

          $scope.currentActivity.ticketId = recent.ticket_id;
          $scope.currentActivity.ticketName = recent.ticket_name;
          if (recent.ticket_id != null) {
            $scope.searchTicket = recent.ticket_id + ", " + recent.ticket_name;
          }
          else {
            $scope.searchTicket = "";
          }
        }
      }

      $scope.openGlossaryActivities = function () {
        var currentScrollPosition = window.scrollY;
        $mdDialog.show({
          controller: $scope.SaveGlossaryActivities,
          clickOutsideToClose: true,
          templateUrl: 'views/activities/_glossary_activities.html',
          scope: $scope,
          preserveScope: true,
          onRemoving: function () {
            window.scrollTo(0, currentScrollPosition);
          }
        })
      };


      $scope.SaveGlossaryActivities = ['$scope', function ($scope) {
        $scope.glossarySearch = { text: '' };
        $scope.glossaryCatalogs = ActivityTypeCatalog.searchGlossary('');
        $scope.searchGlossary = function () {
          $scope.glossaryCatalogs = ActivityTypeCatalog.searchGlossary($scope.glossarySearch.text);
        };
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }];

      $scope.favoritesDrawer = { open: false, search: '', filter: 'all' };
      $scope.allFavoriteTemplates = [];
      $scope.favoriteTemplates = [];
      $scope.quickFavorites = [];
      $scope.armedFavorite = null;
      const QUICK_FAVORITES_LIMIT = 8;
      $scope.favoriteProducts = [];
      $scope.favoriteTypeFilters = [
        { id: 'all', name: 'Todas' },
        { id: 'project', name: 'Proyecto' },
        { id: 'support', name: 'Soporte' },
        { id: 'quote', name: 'Propuesta' },
        { id: 'rh', name: 'RRHH' }
      ];
      $scope.favoriteFormTypes = [
        { id: 'project', name: 'Proyecto' },
        { id: 'support', name: 'Soporte' },
        { id: 'quote', name: 'Propuesta / Comercial' },
        { id: 'rh', name: 'Recursos Humanos' }
      ];

      const emptyFavoriteForm = () => ({
        id: null,
        actionType: 'project',
        description: '',
        projectId: null,
        ownerableId: null,
        ownerableType: null,
        productId: null,
        activityTypeCatalogId: null,
        ticketId: null,
        ticketName: null
      });

      $scope.favoriteForm = emptyFavoriteForm();
      $scope.favoriteSelected = { project: null, customer: null, ticket: null };
      $scope.favoriteSearch = { project: '', customer: '', ticket: '' };

      const favoritesEmployeeId = () => {
        if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
          return $scope.selectedEmployee.id;
        }
        if (!$window.localStorage.apiUser) {
          return null;
        }
        return JSON.parse($window.localStorage.apiUser).employee.id;
      };

      const normalizeText = (text) => (text || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');

      // En memoria: la lista ya esta cargada. La barra rapida omite las no utilizables.
      const applyFavoriteFilters = () => {
        const all = $scope.allFavoriteTemplates || [];
        const text = normalizeText($scope.favoritesDrawer.search).trim();
        const type = $scope.favoritesDrawer.filter;

        $scope.favoriteTemplates = all.filter((template) => {
          if (type !== 'all' && template.action_type !== type) {
            return false;
          }
          if (!text) {
            return true;
          }
          const haystack = normalizeText([
            template.description,
            template.project_name,
            template.project_code,
            template.ownerable_name,
            template.product_catalog_name,
            template.activity_type_catalog_short_name
          ].join(' '));
          return haystack.indexOf(text) !== -1;
        });

        $scope.quickFavorites = all.filter(template => template.usable).slice(0, QUICK_FAVORITES_LIMIT);
      };

      const loadFavoriteTemplates = () => {
        const employeeId = favoritesEmployeeId();
        if (employeeId == null) {
          $scope.allFavoriteTemplates = [];
          applyFavoriteFilters();
          return;
        }

        return ActivityTemplate.mine(employeeId, {}).then((response) => {
          $scope.allFavoriteTemplates = response.data.activity_templates;
          applyFavoriteFilters();
          // Los corazones del calendario salen de esta lista, hay que repintarlos.
          if ($scope.viewObject && $scope.viewObject.calendar) {
            $scope.viewObject.calendar.rerenderEvents();
          }
        }).catch((error) => {
          ActivityTemplate.error(error);
        });
      };

      $scope.importMode = { active: false, pending: [], discarded: [], weekActivities: [], loading: false };

      const refetchCalendar = () => {
        if ($scope.viewObject && $scope.viewObject.calendar) {
          $scope.viewObject.calendar.refetchEvents();
        }
      };

      const importStorageKey = () => {
        const employeeId = JSON.parse($window.localStorage.apiUser).employee.id;
        return 'sia.importPending.' + employeeId;
      };

      // Clave propia: la pantalla anterior guarda su copia en weekCalendar y las
      // dos no se deben pisar mientras convivan.
      const readPendingFromStorage = (startOfWeek) => {
        try {
          const saved = JSON.parse($window.localStorage.getItem(importStorageKey()));
          if (!saved || saved.startOfWeek !== startOfWeek.toISOString()) {
            return null;
          }
          return saved;
        } catch (error) {
          return null;
        }
      };

      const writePendingToStorage = (startOfWeek, pending) => {
        try {
          $window.localStorage.setItem(importStorageKey(), JSON.stringify({
            startOfWeek: startOfWeek.toISOString(),
            active: true,
            pending: pending,
            discarded: $scope.importMode.discarded
          }));
        } catch (error) {
          toaster.pop('warning', 'Importación', 'No se pudo guardar el avance en este navegador.');
        }
      };

      // El modo sobrevive a una recarga: la copia de trabajo vive en el navegador.
      const restoreImportMode = () => {
        try {
          const saved = JSON.parse($window.localStorage.getItem(importStorageKey()));
          $scope.importMode.active = !!(saved && saved.active);
        } catch (error) {
          $scope.importMode.active = false;
        }
      };

      restoreImportMode();

      const clearPendingStorage = () => {
        try {
          $window.localStorage.removeItem(importStorageKey());
        } catch (error) {
          // Sin almacenamiento el modo sigue sirviendo, solo no sobrevive una recarga.
        }
      };

      $scope.canImportFromGoogle = function () {
        return $scope.userhasEmployee() &&
          ($scope.selectedEmployee == null ||
           $scope.selectedEmployee.name === 'Todos' ||
           $scope.selectedEmployeeIsCurrentEmployee());
      };

      const markAsPending = (event, source) => {
        return angular.extend({}, event, {
          isPendingImport: true,
          importSource: source,
          // Se mueven en el calendario para resolver empalmes antes de importar.
          editable: true,
          startEditable: true,
          durationEditable: true,
          title: event.description || event.summary,
          className: 'pending-import',
          color: ImportPendingList.colorFor(event.actionType)
        });
      };

      // FullCalendar entrega moments; la lista y el navegador guardan texto ISO.
      const toPendingDate = (value) => {
        if (!value) {
          return null;
        }

        const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
        return isNaN(date.getTime()) ? null : date.toISOString();
      };

      const reschedulePending = (calendarEvent, view) => {
        const moved = ImportPendingList.reschedule(
          $scope.importMode.pending,
          calendarEvent.id,
          toPendingDate(calendarEvent.start),
          toPendingDate(calendarEvent.end)
        );

        if (!moved) {
          return;
        }

        writePendingToStorage($scope.startOFWeek, $scope.importMode.pending);

        if (view && view.calendar) {
          view.calendar.refetchEvents();
        } else {
          refetchCalendar();
        }
      };

      let importLoadedWeek = null;
      let importLoadPromise = null;

      // El formulario de actividades habla el lenguaje del SIA y el parser el de
      // Google. Esta traduccion permite reusar el modal sin tocarlo.
      const pendingAsActivityShape = (pending) => ({
        id: 0,
        start: pending.start,
        end: pending.end,
        description: pending.description,
        action_type: pending.actionType,
        ownerable_id: pending.clientId,
        ownerable_name: pending.clientName,
        ownerable_type: pending.ownerableType,
        activity_type_catalog_id: pending.activityTypeCatalogId,
        project_id: pending.projectId,
        project_name: pending.projectName,
        project_code: pending.project_code,
        product_id: pending.productId,
        ticket_id: pending.ticketId,
        ticket_name: pending.ticketName,
        editable: true
      });

      const applyClassificationToPending = (pendingId) => {
        const form = $scope.currentActivity || {};

        ImportPendingList.classify($scope.importMode.pending, pendingId, {
          actionType: form.actionType || null,
          description: form.description,
          clientId: form.clientId || null,
          clientName: $scope.selectedCustomer ? $scope.selectedCustomer.name : null,
          ownerableType: form.ownerableType || null,
          activityTypeCatalogId: form.activityTypeCatalogId || null,
          projectId: form.projectId || null,
          projectName: $scope.selectedProject ? $scope.selectedProject.name : null,
          project_code: form.projectCode || null,
          productId: form.productId || null,
          ticketId: form.ticketId || null,
          ticketName: form.ticketName || null
        });

        // El modal deja editar inicio y fin: sin esto se quedaba el horario de Google.
        ImportPendingList.reschedule(
          $scope.importMode.pending,
          pendingId,
          toPendingDate(form.startDate),
          toPendingDate(form.endDate)
        );

        writePendingToStorage($scope.startOFWeek, $scope.importMode.pending);
      };

      function classifyPending(calendarEvent, view) {
        // El calendario entrega una copia: hay que trabajar sobre el de la lista.
        const pending = ImportPendingList.find($scope.importMode.pending, calendarEvent.id);
        if (!pending) {
          return;
        }

        $scope.editOrCreate = 'edit';
        $scope.modalTittle = 'Clasificar actividad de Google Calendar';
        $scope.isDisabled = false;
        $scope.isEditable = true;
        $scope.classifyingPending = true;
        parseCurrentActivity(pendingAsActivityShape(pending));

        // Sin cliente o proyecto todavia, el autocomplete pintaba el objeto crudo.
        if (!pending.clientName) {
          $scope.selectedCustomer = null;
        }

        if (!pending.projectName) {
          $scope.selectedProject = null;
        }

        if (pending.actionType === 'support' || pending.actionType === 'quote') {
          validateCustomerAndFilterProducts(pending.clientId, pending.ownerableType);
        }

        const scrollPosition = window.scrollY;
        $mdDialog.show({
          clickOutsideToClose: true,
          escapeToClose: true,
          controller: $scope.SaveActivityCtrl,
          templateUrl: 'views/activities/_new-activity-modal.html',
          scope: $scope,
          preserveScope: true,
          onRemoving: function () {
            window.scrollTo(0, scrollPosition);
          }
        }).then(() => {
          applyClassificationToPending(pending.id);
          toaster.pop('success', 'Importación', 'Se clasificó. Todavía no se guarda en el SIA.');
        }).catch(() => {
          // Cerrar sin guardar deja el evento como estaba.
        }).finally(() => {
          $scope.classifyingPending = false;
          resetFormState();
          if (view && view.calendar) {
            view.calendar.refetchEvents();
          } else {
            refetchCalendar();
          }
        });
      }

      const applyDiscard = (id) => {
        const result = ImportPendingList.discard(
          $scope.importMode.pending, $scope.importMode.discarded, id
        );

        $scope.importMode.pending = result.pending;
        $scope.importMode.discarded = result.discarded;
        writePendingToStorage($scope.startOFWeek, $scope.importMode.pending);
      };

      $scope.discardPending = (calendarEvent) => {
        applyDiscard(calendarEvent.id);
        refetchCalendar();
        // El clic viene de FullCalendar, fuera del ciclo de Angular.
        $scope.$applyAsync();
      };

      const buildImportPayloads = () => ImportPendingList.importable($scope.importMode.pending).map(
        (pending) => ImportPendingList.toImportPayload(pending, GoogleCalendarEvents.classificationChanges(pending))
      );

      const refreshSummary = () => {
        $scope.summary.loading = true;
        $scope.summary.blocked = ImportPendingList.blocked($scope.importMode.pending);
        $scope.summary.selectable = ImportPendingList.importable($scope.importMode.pending);

        return Activity.previewImport(buildImportPayloads()).then((response) => {
          angular.extend($scope.summary, response.data, { loading: false });
        }).catch((error) => {
          console.error('Error al revisar la importación:', error);
          $scope.summary.loading = false;
          toaster.pop('error', 'Importación', 'No se pudo revisar la importación.');
        });
      };

      $scope.previewImport = () => {
        const blocked = ImportPendingList.blocked($scope.importMode.pending);

        if ($scope.importMode.pending.length === 0) {
          toaster.pop('info', 'Importación', 'No hay actividades pendientes en esta semana.');
          return;
        }

        // Lo que se descarte dentro del resumen se puede deshacer con Cancelar.
        const snapshot = {
          pending: $scope.importMode.pending.slice(),
          discarded: $scope.importMode.discarded.slice()
        };

        $scope.summary = {
          loading: true,
          to_create: 0,
          already_imported: 0,
          without_catalog: 0,
          conflicts: [],
          blocked: blocked,
          selectable: ImportPendingList.importable($scope.importMode.pending)
        };

        $mdDialog.show({
          clickOutsideToClose: false,
          controller: $scope.ImportSummaryCtrl,
          templateUrl: 'views/activities/_import_summary_modal.html',
          scope: $scope,
          preserveScope: true
        }).then(runImport).catch(() => {
          $scope.importMode.pending = snapshot.pending;
          $scope.importMode.discarded = snapshot.discarded;
          writePendingToStorage($scope.startOFWeek, $scope.importMode.pending);
        }).finally(() => {
          // El calendario esta detras del modal: repintarlo antes no surte efecto.
          refetchCalendar();
        });

        refreshSummary();
      };

      function runImport() {
        const payloads = buildImportPayloads();
        if (payloads.length === 0) {
          return;
        }

        cfpLoadingBar.start();
        Activity.importBatch(payloads).then((response) => {
          toaster.pop('success', 'Importación', `Se importaron ${response.data.created} actividades.`);
          // Sin preguntar: ya se guardo, no queda nada que perder.
          closeImportMode();
        }).catch((error) => {
          const data = error.data || {};
          const motivo = data.errors && data.errors.base
            ? data.errors.base.join(' ')
            : 'Revisa los horarios encimados.';
          // La tanda entra completa o no entra: nombrar la que fallo evita
          // tener que adivinar cual de todas detuvo la importacion.
          const cual = data.failed && data.failed.description
            ? `"${data.failed.description}": `
            : '';

          toaster.pop('error', 'No se importó nada', cual + motivo);
        }).finally(() => {
          cfpLoadingBar.complete();
        });
      };

      $scope.ImportSummaryCtrl = ['$scope', function (modalScope) {
        modalScope.anySelectedToDiscard = () =>
          (modalScope.summary.selectable || []).some((item) => item.selectedToDiscard);

        // No cierra el resumen a proposito: el usuario sigue decidiendo.
        modalScope.discardSelected = () => {
          const selected = modalScope.summary.selectable.filter((item) => item.selectedToDiscard);
          if (selected.length === 0) {
            return;
          }

          selected.forEach((item) => {
            item.selectedToDiscard = false;
            applyDiscard(item.id);
          });

          refreshSummary();
        };

        modalScope.restoreFromSummary = () => {
          const result = ImportPendingList.restore($scope.importMode.pending, $scope.importMode.discarded);
          $scope.importMode.pending = result.pending;
          $scope.importMode.discarded = result.discarded;
          writePendingToStorage($scope.startOFWeek, $scope.importMode.pending);
          refreshSummary();
        };

        modalScope.confirm = () => $mdDialog.hide();
        modalScope.cancel = () => $mdDialog.cancel();
      }];

      $scope.openImportCsv = () => {
        if (!$scope.canImportFromGoogle()) {
          toaster.pop('warning', 'Importación', 'Solo puedes importar tus propias actividades.');
          return;
        }

        const scrollPosition = window.scrollY;
        $mdDialog.show({
          controller: $scope.ImportCsvCtrl,
          clickOutsideToClose: false,
          templateUrl: 'views/activities/_import_csv_modal.html',
          scope: $scope,
          preserveScope: true,
          onRemoving: function () {
            window.scrollTo(0, scrollPosition);
          }
        }).then((imported) => {
          $scope.importMode.active = true;
          $scope.importMode.pending = $scope.importMode.pending.concat(
            imported.map((item) => markAsPending(item, 'csv'))
          );
          writePendingToStorage($scope.startOFWeek, $scope.importMode.pending);
          // Lo del archivo ya esta cargado: no hay que ir a Google por ello.
          importLoadedWeek = $scope.startOFWeek.toISOString();
          importLoadPromise = $q.resolve($scope.importMode.pending);
          refetchCalendar();
          toaster.pop('success', 'Importación', `Se cargaron ${imported.length} actividades del archivo.`);
        }).catch(() => {
          // Cerrar sin cargar no cambia nada.
        });
      };

      $scope.ImportCsvCtrl = ['$scope', function (modalScope) {
        modalScope.isSaving = false;
        modalScope.csvFile = null;

        modalScope.downloadFormatCsv = () => Activity.downloadFormatCsv().then((response) => {
          FileSaver.saveAs(new Blob([response.data]), 'Formato_Actividades.csv');
        }).catch((error) => {
          console.error(error);
          toaster.pop('error', 'Actividades', 'No se pudo descargar el formato.');
        });

        modalScope.updateFile = (files) => {
          modalScope.$apply(() => {
            modalScope.csvFile = files[0];
          });
        };

        modalScope.save = () => {
          if (modalScope.isSaving) {
            return;
          }

          // Windows con Excel instalado reporta el csv como vnd.ms-excel, asi
          // que la extension es mas confiable que el tipo que manda el navegador.
          if (!modalScope.csvFile || !/\.csv$/i.test(modalScope.csvFile.name)) {
            toaster.pop('error', 'Importación', 'Selecciona un archivo con extensión .csv');
            return;
          }

          const formData = new FormData();
          formData.append('file', modalScope.csvFile);

          modalScope.isSaving = true;
          cfpLoadingBar.start();

          Activity.ActivitiesCsv(formData, $scope.startOFWeek).then((response) => {
            $mdDialog.hide(response.data.import_activities || []);
          }).catch((error) => {
            const errors = (error.data || {}).errors;
            toaster.pop('error', 'Importación', Array.isArray(errors) ? errors.join(' ') : 'No se pudo leer el archivo.');
          }).finally(() => {
            modalScope.isSaving = false;
            cfpLoadingBar.complete();
          });
        };

        modalScope.cancel = () => $mdDialog.cancel();
      }];

      // El CSV guarda su identificador en la misma columna que Google, con prefijo.
      $scope.importedBreakdown = () => {
        const imported = ($scope.importMode.weekActivities || [])
          .filter((activity) => activity.google_calendar_id);
        const fromCsv = imported.filter((activity) => /^CSV/.test(activity.google_calendar_id)).length;

        return { total: imported.length, csv: fromCsv, google: imported.length - fromCsv };
      };

      $scope.importedThisWeek = () => $scope.importedBreakdown().total;

      $scope.undoWeekImport = () => {
        const { total, google, csv } = $scope.importedBreakdown();

        if (total === 0) {
          toaster.pop('info', 'Importación', 'Esta semana no tiene actividades importadas.');
          return;
        }

        const detalle = [
          google > 0 ? google + ' de Google Calendar' : null,
          csv > 0 ? csv + ' de archivo CSV' : null
        ].filter(Boolean).join(' y ');

        const aviso = 'Se eliminarán del SIA ' + total + ' actividades importadas de esta semana:\n' +
          detalle + '.\n\n' +
          'Lo que capturaste a mano no se toca. Esto no se puede deshacer.\n\n¿Continuar?';

        if (!$window.confirm(aviso)) {
          return;
        }

        cfpLoadingBar.start();
        Activity.removeImportedWeek($scope.startOFWeek).then((response) => {
          toaster.pop('success', 'Importación', `Se eliminaron ${response.data.removed} actividades.`);
          closeImportMode();
        }).catch((error) => {
          const data = error.data || {};
          const message = data.errors && data.errors.base
            ? data.errors.base.join(' ')
            : 'No se pudo deshacer la importación.';
          toaster.pop('error', 'Importación', message);
        }).finally(() => {
          cfpLoadingBar.complete();
        });
      };

      $scope.restoreDiscarded = () => {
        const result = ImportPendingList.restore($scope.importMode.pending, $scope.importMode.discarded);

        $scope.importMode.pending = result.pending;
        $scope.importMode.discarded = result.discarded;
        writePendingToStorage($scope.startOFWeek, $scope.importMode.pending);
        refetchCalendar();
      };

      // El calendario pide sus eventos varias veces seguidas. Todas comparten la
      // misma carga: si cada una siguiera por su lado, una pintaria con la lista
      // aun vacia y el modo se quedaria en blanco.
      const loadGoogleEvents = (startOfWeek, endOfWeek) => {
        const week = startOfWeek.toISOString();

        if (importLoadedWeek === week && importLoadPromise) {
          return importLoadPromise;
        }

        importLoadedWeek = week;

        const saved = readPendingFromStorage(startOfWeek);
        if (saved) {
          // Lo guardado trae las marcas de cuando se guardo: hay que rehacerlas.
          $scope.importMode.pending = (saved.pending || []).map(
            (item) => markAsPending(item, item.importSource)
          );
          $scope.importMode.discarded = saved.discarded || [];
          importLoadPromise = $q.resolve($scope.importMode.pending);
          return importLoadPromise;
        }

        $scope.importMode.loading = true;
        cfpLoadingBar.start();

        importLoadPromise = $q.when(GoogleCalendarEvents.fetchWeek(startOfWeek, endOfWeek, { RRule: RRule }))
          .then((events) => {
            $scope.importMode.pending = events.map((item) => markAsPending(item, 'google'));
            writePendingToStorage(startOfWeek, $scope.importMode.pending);
            return $scope.importMode.pending;
          })
          .catch((error) => {
            console.error('Error al traer los eventos de Google:', error);
            // Se suelta para poder reintentar en el siguiente repintado.
            importLoadedWeek = null;
            importLoadPromise = null;
            $scope.importMode.pending = [];
            return [];
          })
          .finally(() => {
            $scope.importMode.loading = false;
            cfpLoadingBar.complete();
          });

        return importLoadPromise;
      };

      $scope.toggleImportMode = function () {
        if ($scope.importMode.active) {
          $scope.exitImportMode();
          return;
        }

        if (!$scope.canImportFromGoogle()) {
          toaster.pop('warning', 'Importación', 'Solo puedes importar tus propias actividades.');
          return;
        }

        $scope.importMode.active = true;
        loadGoogleEvents($scope.startOFWeek, $scope.endOFWeek).then(refetchCalendar);
      };

      function closeImportMode() {
        $scope.importMode.active = false;
        $scope.importMode.pending = [];
        $scope.importMode.discarded = [];
        importLoadedWeek = null;
        importLoadPromise = null;
        clearPendingStorage();
        refetchCalendar();
      };

      $scope.exitImportMode = function () {
        const clasificadas = $scope.importMode.pending.filter((item) => !item.needsClassification).length;
        const avance = clasificadas > 0 || $scope.importMode.discarded.length > 0;

        if (avance && !$window.confirm('Salir borra lo que clasificaste y descartaste en esta semana. ¿Continuar?')) {
          return;
        }

        closeImportMode();
      };

      $scope.canPlaceFavorites = function () {
        return $scope.editable !== false && !$scope.isMonthLocked;
      };

      $scope.placementBlockedReason = function () {
        if ($scope.isMonthLocked) {
          return 'El mes de ' + $scope.lockedMonthName + ' está bloqueado, no se pueden agregar actividades favoritas.';
        }
        return 'La semana está cerrada, no se pueden agregar actividades favoritas.';
      };

      $scope.armFavorite = function (template) {
        if (!$scope.canPlaceFavorites() || !template.usable) {
          return;
        }
        $scope.armedFavorite = $scope.armedFavorite && $scope.armedFavorite.id === template.id ? null : template;
      };

      $scope.armFavoriteFromDrawer = function (template) {
        $scope.armFavorite(template);
        if ($scope.armedFavorite) {
          $scope.toggleFavoritesDrawer();
        }
      };

      $scope.cancelArmedFavorite = function () {
        $scope.armedFavorite = null;
      };

      const registerArmedFavoriteUse = () => {
        if (!$scope.armedFavorite) {
          return;
        }
        const template = $scope.armedFavorite;
        $scope.armedFavorite = null;
        ActivityTemplate.markAsUsed(template.id).then(() => {
          loadFavoriteTemplates();
        }).catch((error) => {
          console.error(error);
        });
      };

      // fillWithFavoriteValues espera la forma de una actividad favorita vieja.
      const templateAsFavorite = (template) => ({
        action_type: template.action_type,
        description: template.description,
        ownerable_id: template.ownerable_id,
        ownerable_type: template.ownerable_type,
        ownerable_name: template.ownerable_name,
        project_id: template.project_id,
        project_name: template.project_name,
        project_code: template.project_code,
        activity_type_catalog_id: template.activity_type_catalog_id,
        product_id: template.product_catalog_id,
        ticket_id: template.ticket_id,
        ticket_name: template.ticket_name
      });

      $scope.toggleFavoritesDrawer = function () {
        $scope.favoritesDrawer.open = !$scope.favoritesDrawer.open;

        // El ancho del contenido se ajusta fuera de la animacion: si se reacomoda
        // mientras el panel se desliza, el navegador deja un fantasma pintado.
        if ($scope.favoritesDrawer.open) {
          $scope.favoritesDrawer.pushed = true;
          loadFavoriteTemplates();
        } else {
          $timeout(function () {
            $scope.favoritesDrawer.pushed = false;
          }, 320);
        }
        // Solo recalcular tamanos: render() volveria a pedir toda la semana.
        $timeout(function () {
          $window.dispatchEvent(new Event('resize'));
        }, 320);
      };

      $scope.searchFavoriteTemplates = applyFavoriteFilters;

      $scope.filterFavoriteTemplates = function (type) {
        $scope.favoritesDrawer.filter = type;
        applyFavoriteFilters();
      };

      const sameId = (left, right) => (left == null ? null : Number(left)) === (right == null ? null : Number(right));

      // Por coincidencia de valores, no por bandera: ver bitacora.
      const matchesFavorite = (actionType, description, projectId, ownerableId, catalogId) => {
        const target = normalizeText(description).trim();
        if (!target) {
          return false;
        }
        return ($scope.allFavoriteTemplates || []).some(template =>
          template.action_type === actionType &&
          normalizeText(template.description).trim() === target &&
          sameId(template.project_id, projectId) &&
          sameId(template.ownerable_id, ownerableId) &&
          sameId(template.activity_type_catalog_id, catalogId)
        );
      };

      $scope.currentActivityIsFavorite = function () {
        const activity = $scope.currentActivity || {};
        return matchesFavorite(activity.actionType, activity.description, activity.projectId,
          activity.clientId, activity.activityTypeCatalogId);
      };

      $scope.activityIsFavorite = function (activity) {
        return matchesFavorite(activity.action_type, activity.description, activity.project_id,
          activity.ownerable_id, activity.activity_type_catalog_id);
      };

      $scope.favoriteTypeName = function (actionType) {
        const type = $scope.favoriteFormTypes.find(item => item.id === actionType);
        return type ? type.name : 'Vacaciones';
      };

      $scope.favoriteSubtitle = function (template) {
        if (template.action_type === 'project') {
          return template.project_name;
        }
        return [template.ownerable_name, template.product_catalog_name].filter(Boolean).join(' - ');
      };

      const loadFavoriteProducts = (customerId, ownerableType) => {
        if (ownerableType !== 'Client') {
          $scope.favoriteProducts = $scope.productsUnfiltered || [];
          return;
        }
        Client.find(customerId).then((response) => {
          const catalogs = (response.data.client && response.data.client.client_product_catalogs) || [];
          if (catalogs.length === 0) {
            $scope.favoriteProducts = [];
            toaster.pop('error', 'Favoritas', 'Se tienen que configurar los productos del cliente');
            return;
          }
          const allowed = catalogs.map(item => item.product_catalog_id);
          $scope.favoriteProducts = ($scope.productsUnfiltered || []).filter(product => allowed.includes(product.id));
        }).catch((error) => {
          console.error(error);
          toaster.pop('error', 'Favoritas', 'No se pudieron cargar los productos del cliente');
        });
      };

      $scope.favoriteProjectChange = function (project) {
        $scope.favoriteForm.projectId = project ? project.id : null;
        $scope.favoriteForm.ownerableId = project ? project.client_id : null;
        $scope.favoriteForm.ownerableType = project ? 'Client' : null;
      };

      // md-selected-item-change dispara con undefined al reemplazar: no vaciar productos.
      $scope.favoriteCustomerChange = function (customer) {
        if (!customer) {
          $scope.favoriteForm.ownerableId = null;
          $scope.favoriteForm.ownerableType = null;
          return;
        }
        $scope.favoriteForm.ownerableId = customer.id;
        $scope.favoriteForm.ownerableType = customer.search_type === 'Prospect' ? 'Prospect' : 'Client';
        loadFavoriteProducts(customer.id, $scope.favoriteForm.ownerableType);
      };

      $scope.favoriteTicketChange = function (ticket) {
        $scope.favoriteForm.ticketId = ticket ? ticket.id : null;
        $scope.favoriteForm.ticketName = ticket ? ticket.title : null;
      };

      $scope.updateFavoriteActionType = function () {
        const actionType = $scope.favoriteForm.actionType;
        const description = $scope.favoriteForm.description;
        // Sin el id, guardar daria de alta otra favorita en vez de editar esta.
        const id = $scope.favoriteForm.id;
        $scope.favoriteForm = angular.extend(emptyFavoriteForm(), { id: id, actionType: actionType, description: description });
        $scope.favoriteSelected = { project: null, customer: null, ticket: null };
        $scope.favoriteSearch = { project: '', customer: '', ticket: '' };
        $scope.favoriteProducts = [];

        if (actionType === 'rh') {
          $scope.favoriteForm.ownerableId = Number(sessionStorage.default_customer_id);
          $scope.favoriteForm.ownerableType = 'Client';
        }
      };

      $scope.resetFavoriteForm = function () {
        $scope.favoriteForm = emptyFavoriteForm();
        $scope.favoriteSelected = { project: null, customer: null, ticket: null };
        $scope.favoriteSearch = { project: '', customer: '', ticket: '' };
        $scope.favoriteProducts = [];
      };

      $scope.saveFavoriteTemplate = function () {
        const payload = {
          activity_template: {
            id: $scope.favoriteForm.id,
            action_type: $scope.favoriteForm.actionType,
            description: $scope.favoriteForm.description,
            project_id: $scope.favoriteForm.projectId,
            ownerable_id: $scope.favoriteForm.ownerableId,
            ownerable_type: $scope.favoriteForm.ownerableType,
            product_catalog_id: $scope.favoriteForm.productId,
            activity_type_catalog_id: $scope.favoriteForm.activityTypeCatalogId,
            ticket_id: $scope.favoriteForm.ticketId,
            ticket_name: $scope.favoriteForm.ticketName
          }
        };

        cfpLoadingBar.start();
        ActivityTemplate.save(payload).then(() => {
          toaster.pop('success', 'Favoritas', 'La actividad favorita se guardó correctamente');
          $scope.resetFavoriteForm();
          loadFavoriteTemplates();
        }).catch((error) => {
          ActivityTemplate.error(error);
        }).finally(() => {
          cfpLoadingBar.complete();
        });
      };

      $scope.editFavoriteTemplate = function (template) {
        $scope.favoriteForm = {
          id: template.id,
          actionType: template.action_type,
          description: template.description,
          projectId: template.project_id,
          ownerableId: template.ownerable_id,
          ownerableType: template.ownerable_type,
          productId: template.product_catalog_id,
          activityTypeCatalogId: template.activity_type_catalog_id,
          ticketId: template.ticket_id,
          ticketName: template.ticket_name
        };
        $scope.favoriteSelected = {
          project: template.project_id ? { id: template.project_id, name: template.project_name } : null,
          customer: template.ownerable_id ? { id: template.ownerable_id, name: template.ownerable_name } : null,
          ticket: template.ticket_id ? { id: template.ticket_id, title: template.ticket_name } : null
        };
        $scope.favoriteSearch = {
          project: template.project_name || '',
          customer: template.ownerable_name || '',
          ticket: template.ticket_id ? template.ticket_id + ', ' + template.ticket_name : ''
        };

        if (template.ownerable_type === 'Client' && template.action_type !== 'project') {
          loadFavoriteProducts(template.ownerable_id, 'Client');
        }

        // El formulario vive arriba del listado, hay que subir a verlo.
        $timeout(function () {
          const body = document.querySelector('.favorites-drawer-body');
          if (body) {
            body.scrollTop = 0;
          }
        });
      };

      $scope.deleteFavoriteTemplate = function (template) {
        cfpLoadingBar.start();
        ActivityTemplate.delete(template.id).then(() => {
          toaster.pop('success', 'Favoritas', 'La actividad favorita se eliminó correctamente');
          if ($scope.favoriteForm.id === template.id) {
            $scope.resetFavoriteForm();
          }
          if ($scope.armedFavorite && $scope.armedFavorite.id === template.id) {
            $scope.armedFavorite = null;
          }
          loadFavoriteTemplates();
        }).catch((error) => {
          ActivityTemplate.error(error);
        }).finally(() => {
          cfpLoadingBar.complete();
        });
      };

      // Una actividad de 15 minutos solo alcanza a mostrar la hora y el icono.
      const activityTooltip = (event) => {
        const start = moment(event.start._d).format('h:mm');
        const end = moment(event.end._d).format('h:mm');
        const lines = [event.description || event.title, `${start} - ${end}`];

        if (event.isPendingImport) {
          lines.push(event.importSource === 'csv' ? 'Del archivo, sin importar' : 'De Google Calendar, sin importar');
          return lines.join('\n');
        }

        if (event.action_type === 'project' && event.project_name) {
          lines.push(`Proyecto: [SCISA_${event.project_code}] ${event.project_name}`);
        } else if (event.ownerable_name) {
          lines.push(`Cliente: ${event.ownerable_name}`);
        }
        if (event.ticket_id) {
          lines.push(`Ticket: ${event.ticket_id}`);
        }

        return lines.filter(Boolean).join('\n');
      };

      $scope.uiConfig = {
        calendar: {
          timezone: 'local',
          firstDay: 1,
          droppable: true,
          nowIndicator: true,
          allDaySlot: true,
          allDayText: 'Todo el día',
          selectable: true,
          scrollTime: scrollTime,
          defaultView: 'agendaWeek',
          slotDuration: "00:15:00",
          header: {
            left: 'myCustomButton googleImportButton csvImportButton',
            center: 'title',
            right: 'today prev,next'
          },
          customButtons: {
            myCustomButton: {
              text: 'Glosario de Actividades',
              click: async function () {
                $scope.openGlossaryActivities();
              }
            },
            googleImportButton: {
              text: 'Importar actividades localmente (Google Calendar)',
              click: function () {
                $scope.$apply($scope.toggleImportMode);
              }
            },
            csvImportButton: {
              text: 'Importar actividades localmente (CSV)',
              click: function () {
                $scope.$apply($scope.openImportCsv);
              }
            },
          },
          dayClick: ((date, jsEvent, view) => {
            $scope.allDaySelected = false;
            if (!date.hasTime()) {
              $scope.allDaySelected = true;
            }
          }),
          eventClick: $scope.eventClick,
          eventDrop: $scope.eventDrop,
          eventResize: $scope.alertOnResize,
          viewRender: ((view, element) => {
            $scope.viewObject = view;
          }),
          events: ((start, end, timezone, callback) => {
            var startOfDay = new Date(start.clone().add(1, 'days'));
            var endOfDay = new Date(end.clone());
            endOfDay.setHours(23, 59, 59, 999);
            startOfDay.setHours(0, 0, 0, 0);

            $scope.startOFWeek = startOfDay;
            $scope.endOFWeek = endOfDay;
            loadFavoriteTemplates();
            getRecentActivities();
            getWeekHolydays(startOfDay, endOfDay);
            getActivities(startOfDay, endOfDay).then((events) => {
              if ($scope.editable) {
                for (var i in events) {
                  events[i].editable = true;
                  if (events[i].action_type == 'vacation') {
                    events[i].color = '#5F9EA0';
                  } else if (events[i].action_type == 'quote') {
                    events[i].color = '#7a7db3';
                  } else if (events[i].action_type == 'support') {
                    events[i].color = '#df6c11';
                  } else if (events[i].action_type == 'internal') {
                    events[i].color = '#e3a60d';
                  } else if (events[i].action_type == 'project') {
                    events[i].color = '#4153c8';
                  }
                }
              } else {
                for (var i in events) {
                  events[i].editable = false;
                  events[i].color = '#D31414';
                }
              }
              if (!$scope.importMode.active) {
                callback(events);
                return;
              }

              // $scope.activities acumula entre semanas; estas son las de la vista.
              $scope.importMode.weekActivities = events;

              // Siempre se espera la carga: devuelve la misma al cambiar de
              // semana o al repintar, asi que no vuelve a pedirle nada a Google.
              loadGoogleEvents(startOfDay, endOfDay).then(() => {
                // Lo que ya tiene actividad en el SIA deja de ser pendiente.
                $scope.importMode.pending = ImportPendingList.withoutAlreadyImported(
                  $scope.importMode.pending, events
                );
                callback(events.concat($scope.importMode.pending));
              });
            })
          }),
          select: $scope.select,
          eventDragStart: $scope.eventDragStart,
          eventRender: ((event, element, view) => {
            element.attr('title', activityTooltip(event));
            element.html(
              `
            <i class="fa fa-clock-o" aria-hidden="true" style="padding: 5px 0px 0px 5px;"></i>
            <i style="font-family: sans-serif; font-style: normal; font-size: 13px;">${moment(event.start._d).format("h:mm")} - ${moment(event.end._d).format("h:mm")}</i>
            <br/>
            <br/>
            <i class="fa fa-pencil-square-o" aria-hidden="true" style="font-size: 14px; padding: 5px 0px 0px 5px;"> </i>
            <i style="font-family: sans-serif; font-style: normal;">${event.title}</i>

            `
            );
            if (isPendingImport(event)) {
              const icono = event.importSource === 'csv' ? 'fa-file-text-o' : 'fa-google';
              element.attr('data-cy', 'pending-import');
              element.prepend(
                `<span class="pending-import-tag">
                   <i class="fa ${icono}" aria-hidden="true"></i> Sin importar
                 </span>
                 <button type="button" class="pending-import-discard" data-cy="pending-import-discard"
                   title="Descartar: no se importará">&times;</button>`
              );
            } else if ($scope.importMode.active && event.google_calendar_id) {
              // El CSV guarda su propio identificador con prefijo en esa columna.
              const origen = /^CSV/.test(event.google_calendar_id) ? 'fa-file-text-o' : 'fa-google';
              element.prepend(
                `<span class="imported-tag" data-cy="imported-tag">
                   <i class="fa ${origen}" aria-hidden="true"></i> Ya en el SIA
                 </span>`
              );
            }
            if (event.action_type == 'project') {
              element.append(
                `
              <br/>
              <i class="fa fa-folder-open" aria-hidden="true" style="padding: 5px 0px 0px 5px; color: ${event.color_tag}"> </i>
              <i style="font-family: sans-serif; font-style: normal;">SCISA_${event.project_code}</i>
              `
              );
            }
            if (event.ticket_id != null) {
              element.append(
                `
              <br/>
              <i class="fa fa-tasks" aria-hidden="true" style="padding: 5px 0px 0px 5px;"></i>
              <i style="font-family: sans-serif; font-style: normal;">Ticket ${event.ticket_id}</i>
              `
              );
            }
            if ($scope.activityIsFavorite(event)) {
              element.append('<i class="fa fa-heart activity-favorite-flag" aria-hidden="true" title="Tienes una favorita con estos datos"></i>');
            }
            if (event.editable) {
              view.calendar.unselect();
              element.prepend(`
                <div class="fc-resizer fc-end-resizer"></div>
                <i
                  class="fa fa-files-o pull-right copy-icon"
                  aria-hidden="true"
                  style="margin: 4px; padding:0; transition: transform .2s; font-size: 30px;"
                  onmouseover="this.style.color='#1E90FF'"
                  onmouseout="this.style.color='white'"
                >
                </i>
              `);

              setTimeout(() => {
                element.find('.copy-icon').on('mousedown', () => {
                  event.isCopy = true;
                });
              }, 0);
            }

            $scope.onButtonOneClick = () => {
              if (window.confirm('¿Estas seguro que deseas cerrar tus actividades de la semana? Ya no podras hacerles modificaciones.')) {
                Activity.closeActivities({
                  by_begins_at: {
                    start_date: formatLocalDate($scope.startOFWeek),
                    end_date: formatLocalDate($scope.endOFWeek)
                  },
                  by_employee: JSON.parse(window.localStorage.apiUser).employee.id,
                  by_editable: true
                }).then((response) => {
                  toaster.pop('success', 'Actividad', 'La semana se cerro correctamente');
                  $scope.viewObject.calendar.refetchEvents();
                }).catch(error => {
                  toaster.pop('error', 'Actividad', error.data.error);
                });
              }
            }
          }),
          eventOverlap: ((stillEvent, movingEvent) => {
            return stillEvent.allDay && movingEvent.allDay;
          })
        }
      };

      function formatLocalDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      $scope.openWeek = () => {
        if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
          if (window.confirm('¿Estas seguro que deseas descongelar la semana de actividades de ' + $scope.selectedEmployee.name + '?')) {
            Activity.openActivities({
              by_begins_at: {
                start_date: $scope.startOFWeek,
                end_date: $scope.endOFWeek
              },
              by_employee: $scope.selectedEmployee.id,
              not_editable: true
            }).then((response) => {
              toaster.pop('success', 'Actividad', 'La semana se descongelo correctamente');
              $scope.viewObject.calendar.refetchEvents();
            }).catch(error => {
              toaster.pop('error', 'Actividad', error.data.error);
            });
          }
        } else {
          toaster.pop('error', 'Actividad', "Favor de seleccionar un empleado para poder descongelar la semana");
        }
      }

      $scope.closeOtherEmployeeWeek = () => {
        if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
          if (window.confirm('¿Estas seguro que deseas congelar la semana de actividades de ' + $scope.selectedEmployee.name + '?')) {
            Activity.closeActivities({
              by_begins_at: {
                start_date: $scope.startOFWeek,
                end_date: $scope.endOFWeek
              },
              by_employee: $scope.selectedEmployee.id,
              by_editable: true
            }).then((response) => {
              toaster.pop('success', 'Actividad', 'La semana se cerro correctamente');
              $scope.viewObject.calendar.refetchEvents();
            }).catch(error => {
              toaster.pop('error', 'Actividad', error.data.error);
            });
          }
        } else {
          toaster.pop('error', 'Actividad', "Favor de seleccionar un empleado para poder descongelar la semana");
        }
      }

      $scope.openMonth = () => {
        if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
          if (window.confirm('¿Estas seguro que deseas descongelar el Mes de actividades de ' + $scope.selectedEmployee.name + '?')) {
            // En las semanas que cruzan de mes, el bloqueado no es el del lunes.
            let base = $scope.lockedMonthDate || $scope.startOFWeek;
            let monthStart = new Date(base.getFullYear(), base.getMonth(), 1);
            monthStart.setHours(0, 0, 0, 0);
            let monthEnd = new Date(base.getFullYear(), base.getMonth() + 1, 0);
            monthEnd.setHours(23, 59, 59, 999);
            Activity.openMonthActivities({
              by_begins_at: {
                start_date: formatLocalDate(monthStart),
                end_date: formatLocalDate(monthEnd)
              },
              by_employee: $scope.selectedEmployee.id,
            }).then((response) => {
              toaster.pop('success', 'Actividad', 'El Mes se descongelo correctamente');
              $scope.viewObject.calendar.refetchEvents();
            }).catch(error => {
              toaster.pop('error', 'Actividad', error.data.error);
            });
          }
        } else {
          toaster.pop('error', 'Actividad', "Favor de seleccionar un empleado para poder descongelar el Mes");
        }
      }

      $scope.isDifferentMonth = function (dt = $scope.startOFWeek) {
        if (!dt) return false;
        const d = new Date(dt);
        const now = new Date();

        const sameMonth =
          d.getFullYear() === now.getFullYear() &&
          d.getMonth() === now.getMonth();

        return !sameMonth;
      };

      $scope.closeOtherEmployeeMonth = () => {
        if ($scope.selectedEmployee != null && $scope.selectedEmployee.name != 'Todos') {
          if (window.confirm('¿Estas seguro que deseas congelar el Mes de actividades de ' + $scope.selectedEmployee.name + '?')) {
            let startOfWeek = $scope.startOFWeek;
            let monthStart = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), 1);
            monthStart.setHours(0, 0, 0, 0);
            let monthEnd = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth() + 1, 0);
            monthEnd.setHours(23, 59, 59, 999);
            Activity.closeMonthActivities({
              by_begins_at: {
                start_date: formatLocalDate(monthStart),
                end_date: formatLocalDate(monthEnd)
              },
              by_employee: $scope.selectedEmployee.id,
            }).then((response) => {
              toaster.pop('success', 'Actividad', 'El Mes se cerro correctamente');
              $scope.viewObject.calendar.refetchEvents();
            }).catch(error => {
              toaster.pop('error', 'Actividad', error.data.error);
            });
          }
        } else {
          toaster.pop('error', 'Actividad', "Favor de seleccionar un empleado para poder descongelar el Mes");
        }
      }

      cfpLoadingBar.start();
      getCatalogParmas().finally(() => cfpLoadingBar.complete());
      getDefaultDate();
    }]);
